export default "__VITE_ASSET__Dy_Gop0B__"